// Enums da Movimentação de Estoque — valores em inglês maiúsculo (ver Seção 2
// da spec). As chaves de i18n usam a versão em minúsculo/camelCase.

export const MOVEMENT_TYPES = {
  ENTRY: "ENTRY",
  EXIT: "EXIT",
};

export const ENTRY_ORIGINS = ["PURCHASE", "PRODUCTION"];

export const EXIT_ORIGINS = ["WITHDRAWAL"];

export const STATUS = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  AUDIT: "AUDIT",
  INACTIVE: "INACTIVE",
};

export const DOCUMENT_TYPES = ["INVOICE"];

export const EXPIRATION_MODES = {
  DATE: "DATE",
  DAYS: "DAYS",
};

// Cores das Tags (Ant Design 3.x).
export const TYPE_TAG_COLOR = {
  ENTRY: "green",
  EXIT: "red",
};

export const STATUS_TAG_COLOR = {
  PENDING: "gold",
  COMPLETED: "green",
  AUDIT: "volcano",
  INACTIVE: "default",
  PROCESSING: "blue",
  ERROR: "red",
};

// Mapeia valor de enum (EN maiúsculo) → chave i18n (camelCase).
export const toI18nKey = (value) => {
  if (!value) return "";
  return value.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
};
